import type { FC } from "react";
import { ASSISTANT_AVATAR } from "@/theme/tokens";
import { AssistantAvatarHair } from "@/ui/AssistantAvatar/assistantAvatarConfig";

type HairLayer = FC<{ color: string }>;

const FRONT_CURLS = [
	{ cx: 44, cy: 37 },
	{ cx: 52, cy: 32 },
	{ cx: 60, cy: 30 },
	{ cx: 68, cy: 32 },
	{ cx: 76, cy: 37 },
] as const;

const fringe =
	(d: string, opacity?: number): HairLayer =>
	({ color }) => <path d={d} fill={color} opacity={opacity} />;

/** The hair layer over the forehead, drawn after the face. */
const HAIR_FRONT: Record<AssistantAvatarHair, HairLayer> = {
	[AssistantAvatarHair.Short]: fringe("M35 58 C33 36 44 27 60 27 C77 27 88 37 85 58 C84 50 80 44 76 42 C68 46 52 46 42 42 C39 46 36 51 35 58Z"),
	[AssistantAvatarHair.Bob]: fringe("M35 56 C34 36 46 28 60 28 C74 28 86 36 85 56 C80 44 70 38 58 40 C48 42 40 48 35 56Z"),
	[AssistantAvatarHair.Long]: fringe("M35 60 C33 36 46 27 62 27 C76 27 87 38 85 60 C82 48 74 40 64 36 C58 44 46 50 35 60Z"),
	[AssistantAvatarHair.Curly]: ({ color }) => (
		<g>
			{FRONT_CURLS.map(({ cx, cy }) => (
				<circle key={cx} cx={cx} cy={cy} r={7.5} fill={color} />
			))}
		</g>
	),
	[AssistantAvatarHair.Bun]: fringe("M36 54 C36 36 46 28 60 28 C74 28 84 36 84 54 C78 42 68 38 60 38 C52 38 42 42 36 54Z"),
	[AssistantAvatarHair.Buzz]: fringe("M37 52 C37 34 48 30 60 30 C72 30 83 34 83 52 C76 42 44 42 37 52Z", ASSISTANT_AVATAR.OPACITY.BUZZ),
};

export const HumanHairFront: FC<{ hair: AssistantAvatarHair; color: string }> = ({ hair, color }) => {
	const Layer = HAIR_FRONT[hair];
	return <Layer color={color} />;
};
